import { Zap } from "lucide-react";

export default function FlashDealBadge({ discount }) {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-red-600 px-3 py-1.5 text-[10px] font-black uppercase tracking-wide text-white shadow-lg shadow-red-600/20">
      <Zap className="size-3 fill-current" />
      {discount}% Off
    </span>
  );
}